<template>
  <div ref="container" class="learning-chart">
    <apexchart v-if="width" :type="type" :height="height" :width="width" :options="options" :series="series" />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
export default {
  components:{apexchart:VueApexCharts},
  props:{type:String,height:[String,Number],options:Object,series:Array},
  data:()=>({width:0,observer:null}),
  mounted(){
    this.measure();
    // The app drawer animates v-main's padding after charts mount. Track the actual
    // panel width so plots resize during that transition and when the drawer toggles.
    if (typeof ResizeObserver !== 'undefined') {
      this.observer=new ResizeObserver(this.measure);
      this.observer.observe(this.$refs.container);
    } else window.addEventListener('resize',this.measure);
  },
  beforeDestroy(){if(this.observer)this.observer.disconnect();window.removeEventListener('resize',this.measure);},
  methods:{measure(){const width=Math.floor(this.$refs.container?.getBoundingClientRect().width || 0);if(width>0 && width!==this.width)this.width=width;}},
};
</script>
<style scoped>
.learning-chart{width:100%;min-width:0;overflow:hidden}
</style>
